import React from 'react';

export default class Label extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { htmlFor, className = '', children } = this.props;

		return (
			<label htmlFor={htmlFor} className={`text-gray-800 dark:text-dark-text ${className}`}>
				{children}
			</label>
		);
	}
}
